import * as te from "react";
import nt, { forwardRef as ot, useContext as Ut, useRef as Bt, useCallback as qt, useEffect as it, useMemo as we, useState as Ue } from "react";
import { motion as Gt, AnimatePresence as Be } from "framer-motion";
import { v4 as at } from "uuid";
import { globalColor as le, illaPrefix as de, zIndex as Jt, getColor as qe, applyBoxStyle as Te } from "@illa-design/theme";
import { css as q } from "@emotion/react";
import { WarningCircleIcon as Kt, SuccessCircleIcon as Ht, ErrorCircleIcon as Zt, InfoCircleIcon as Xt, CloseIcon as Qt } from "@illa-design/icon";
var yr = { exports: {} }, Se = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zr;
function en() {
  if (zr)
    return Se;
  zr = 1;
  var e = nt, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(f, p, m) {
    var d, g = {}, E = null, v = null;
    m !== void 0 && (E = "" + m), p.key !== void 0 && (E = "" + p.key), p.ref !== void 0 && (v = p.ref);
    for (d in p)
      o.call(p, d) && !a.hasOwnProperty(d) && (g[d] = p[d]);
    if (f && f.defaultProps)
      for (d in p = f.defaultProps, p)
        g[d] === void 0 && (g[d] = p[d]);
    return { $$typeof: r, type: f, key: E, ref: v, props: g, _owner: i.current };
  }
  return Se.Fragment = n, Se.jsx = l, Se.jsxs = l, Se;
}
var Re = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ur;
function rn() {
  return Ur || (Ur = 1, process.env.NODE_ENV !== "production" && function() {
    var e = nt, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), f = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), b = Symbol.iterator, x = "@@iterator";
    function I(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = b && t[b] || t[x];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), y = 1; y < s; y++)
          u[y - 1] = arguments[y];
        $("error", t, u);
      }
    }
    function $(t, s, u) {
      {
        var y = S.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (s += "%s", u = u.concat([w]));
        var k = u.map(function(C) {
          return String(C);
        });
        k.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, k);
      }
    }
    var L = !1, c = !1, V = !1, A = !1, ir = !1, Ie;
    Ie = Symbol.for("react.module.reference");
    function ar(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === o || t === a || ir || t === i || t === m || t === d || A || t === v || L || c || V || typeof t == "object" && t !== null && (t.$$typeof === E || t.$$typeof === g || t.$$typeof === l || t.$$typeof === f || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Ie || t.getModuleId !== void 0));
    }
    function sr(t, s, u) {
      var y = t.displayName;
      if (y)
        return y;
      var w = s.displayName || s.name || "";
      return w !== "" ? u + "(" + w + ")" : u;
    }
    function Le(t) {
      return t.displayName || "Context";
    }
    function H(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case f:
            var s = t;
            return Le(s) + ".Consumer";
          case l:
            var u = t;
            return Le(u._context) + ".Provider";
          case p:
            return sr(t, t.render, "ForwardRef");
          case g:
            var y = t.displayName || null;
            return y !== null ? y : H(t.type) || "Memo";
          case E: {
            var w = t, k = w._payload, C = w._init;
            try {
              return H(C(k));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, ne = 0, De, Me, ve, Fe, ye, je, Ve;
    function Ye() {
    }
    Ye.__reactDisabledLog = !0;
    function cr() {
      {
        if (ne === 0) {
          De = console.log, Me = console.info, ve = console.warn, Fe = console.error, ye = console.group, je = console.groupCollapsed, Ve = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ye,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function ur() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, t, {
              value: De
            }),
            info: ee({}, t, {
              value: Me
            }),
            warn: ee({}, t, {
              value: ve
            }),
            error: ee({}, t, {
              value: Fe
            }),
            group: ee({}, t, {
              value: ye
            }),
            groupCollapsed: ee({}, t, {
              value: je
            }),
            groupEnd: ee({}, t, {
              value: Ve
            })
          });
        }
        ne < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ge = S.ReactCurrentDispatcher, Ee;
    function ie(t, s, u) {
      {
        if (Ee === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ee = y && y[1] || "";
          }
        return `
` + Ee + t;
      }
    }
    var be = !1, ae;
    {
      var fr = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new fr();
    }
    function h(t, s) {
      if (!t || be)
        return "";
      {
        var u = ae.get(t);
        if (u !== void 0)
          return u;
      }
      var y;
      be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var k;
      k = ge.current, ge.current = null, cr();
      try {
        if (s) {
          var C = function() {
            throw Error();
          };
          if (Object.defineProperty(C.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(C, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], C);
          } else {
            try {
              C.call();
            } catch (re) {
              y = re;
            }
            t.call(C.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var R = re.stack.split(`
`), U = y.stack.split(`
`), M = R.length - 1, F = U.length - 1; M >= 1 && F >= 0 && R[M] !== U[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (R[M] !== U[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || R[M] !== U[F]) {
                    var K = `
` + R[M].replace(" at new ", " at ");
                    return t.displayName && K.includes("<anonymous>") && (K = K.replace("<anonymous>", t.displayName)), typeof t == "function" && ae.set(t, K), K;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        be = !1, ge.current = k, ur(), Error.prepareStackTrace = w;
      }
      var ue = t ? t.displayName || t.name : "", Wr = ue ? ie(ue) : "";
      return typeof t == "function" && ae.set(t, Wr), Wr;
    }
    function xe(t, s, u) {
      return h(t, !1);
    }
    function se(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function oe(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return h(t, se(t));
      if (typeof t == "string")
        return ie(t);
      switch (t) {
        case m:
          return ie("Suspense");
        case d:
          return ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return xe(t.render);
          case g:
            return oe(t.type, s, u);
          case E: {
            var y = t, w = y._payload, k = y._init;
            try {
              return oe(k(w), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var We = Object.prototype.hasOwnProperty, Pr = {}, Ar = S.ReactDebugCurrentFrame;
    function ze(t) {
      if (t) {
        var s = t._owner, u = oe(t.type, t._source, s ? s.type : null);
        Ar.setExtraStackFrame(u);
      } else
        Ar.setExtraStackFrame(null);
    }
    function Rt(t, s, u, y, w) {
      {
        var k = Function.call.bind(We);
        for (var C in t)
          if (k(t, C)) {
            var R = void 0;
            try {
              if (typeof t[C] != "function") {
                var U = Error((y || "React class") + ": " + u + " type `" + C + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[C] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw U.name = "Invariant Violation", U;
              }
              R = t[C](s, C, y, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              R = M;
            }
            R && !(R instanceof Error) && (ze(w), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", u, C, typeof R), ze(null)), R instanceof Error && !(R.message in Pr) && (Pr[R.message] = !0, ze(w), _("Failed %s type: %s", u, R.message), ze(null));
          }
      }
    }
    var Ct = Array.isArray;
    function lr(t) {
      return Ct(t);
    }
    function wt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function Tt(t) {
      try {
        return $r(t), !1;
      } catch {
        return !0;
      }
    }
    function $r(t) {
      return "" + t;
    }
    function kr(t) {
      if (Tt(t))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", wt(t)), $r(t);
    }
    var _e = S.ReactCurrentOwner, Nt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ir, Lr, dr;
    dr = {};
    function Ot(t) {
      if (We.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Pt(t) {
      if (We.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function At(t, s) {
      if (typeof t.ref == "string" && _e.current && s && _e.current.stateNode !== s) {
        var u = H(_e.current.type);
        dr[u] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', H(_e.current.type), t.ref), dr[u] = !0);
      }
    }
    function $t(t, s) {
      {
        var u = function() {
          Ir || (Ir = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function kt(t, s) {
      {
        var u = function() {
          Lr || (Lr = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var It = function(t, s, u, y, w, k, C) {
      var R = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: C,
        // Record the component responsible for creating this element.
        _owner: k
      };
      return R._store = {}, Object.defineProperty(R._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(R, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(R, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(R.props), Object.freeze(R)), R;
    };
    function Lt(t, s, u, y, w) {
      {
        var k, C = {}, R = null, U = null;
        u !== void 0 && (kr(u), R = "" + u), Pt(s) && (kr(s.key), R = "" + s.key), Ot(s) && (U = s.ref, At(s, w));
        for (k in s)
          We.call(s, k) && !Nt.hasOwnProperty(k) && (C[k] = s[k]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (k in M)
            C[k] === void 0 && (C[k] = M[k]);
        }
        if (R || U) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          R && $t(C, F), U && kt(C, F);
        }
        return It(t, R, U, w, y, _e.current, C);
      }
    }
    var pr = S.ReactCurrentOwner, Dr = S.ReactDebugCurrentFrame;
    function ce(t) {
      if (t) {
        var s = t._owner, u = oe(t.type, t._source, s ? s.type : null);
        Dr.setExtraStackFrame(u);
      } else
        Dr.setExtraStackFrame(null);
    }
    var hr;
    hr = !1;
    function mr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Mr() {
      {
        if (pr.current) {
          var t = H(pr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Dt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Fr = {};
    function Mt(t) {
      {
        var s = Mr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function jr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = Mt(s);
        if (Fr[u])
          return;
        Fr[u] = !0;
        var y = "";
        t && t._owner && t._owner !== pr.current && (y = " It was passed a child from " + H(t._owner.type) + "."), ce(t), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, y), ce(null);
      }
    }
    function Vr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (lr(t))
          for (var u = 0; u < t.length; u++) {
            var y = t[u];
            mr(y) && jr(y, s);
          }
        else if (mr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = I(t);
          if (typeof w == "function" && w !== t.entries)
            for (var k = w.call(t), C; !(C = k.next()).done; )
              mr(C.value) && jr(C.value, s);
        }
      }
    }
    function Ft(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === g))
          u = s.propTypes;
        else
          return;
        if (u) {
          var y = H(s);
          Rt(u, t.props, "prop", y, t);
        } else if (s.PropTypes !== void 0 && !hr) {
          hr = !0;
          var w = H(s);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function jt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var y = s[u];
          if (y !== "children" && y !== "key") {
            ce(t), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), ce(null);
            break;
          }
        }
        t.ref !== null && (ce(t), _("Invalid attribute `ref` supplied to `React.Fragment`."), ce(null));
      }
    }
    function Yr(t, s, u, y, w, k) {
      {
        var C = ar(t);
        if (!C) {
          var R = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (R += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var U = Dt(w);
          U ? R += U : R += Mr();
          var M;
          t === null ? M = "null" : lr(t) ? M = "array" : t !== void 0 && t.$$typeof === r ? (M = "<" + (H(t.type) || "Unknown") + " />", R = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, R);
        }
        var F = Lt(t, s, u, w, k);
        if (F == null)
          return F;
        if (C) {
          var K = s.children;
          if (K !== void 0)
            if (y)
              if (lr(K)) {
                for (var ue = 0; ue < K.length; ue++)
                  Vr(K[ue], t);
                Object.freeze && Object.freeze(K);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Vr(K, t);
        }
        return t === o ? jt(F) : Ft(F), F;
      }
    }
    function Vt(t, s, u) {
      return Yr(t, s, u, !0);
    }
    function Yt(t, s, u) {
      return Yr(t, s, u, !1);
    }
    var Wt = Yt, zt = Vt;
    Re.Fragment = o, Re.jsx = Wt, Re.jsxs = zt;
  }()), Re;
}
process.env.NODE_ENV === "production" ? yr.exports = en() : yr.exports = rn();
var Oe = yr.exports;
function tn(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function nn(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var on = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(i) {
      var a;
      o.tags.length === 0 ? o.insertionPoint ? a = o.insertionPoint.nextSibling : o.prepend ? a = o.container.firstChild : a = o.before : a = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(i, a), o.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, r.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(nn(this));
    var i = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var a = o.charCodeAt(0) === 64 && o.charCodeAt(1) === 105;
      a && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + o + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !a;
    }
    if (this.isSpeedy) {
      var l = tn(i);
      try {
        l.insertRule(o, l.cssRules.length);
      } catch (f) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(o) && console.error('There was a problem inserting the following rule: "' + o + '"', f);
      }
    } else
      i.appendChild(document.createTextNode(o));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(o) {
      return o.parentNode && o.parentNode.removeChild(o);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), W = "-ms-", Qe = "-moz-", T = "-webkit-", Rr = "comm", Cr = "rule", wr = "decl", an = "@import", st = "@keyframes", sn = "@layer", cn = Math.abs, rr = String.fromCharCode, un = Object.assign;
function fn(e, r) {
  return Y(e, 0) ^ 45 ? (((r << 2 ^ Y(e, 0)) << 2 ^ Y(e, 1)) << 2 ^ Y(e, 2)) << 2 ^ Y(e, 3) : 0;
}
function ct(e) {
  return e.trim();
}
function ln(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function N(e, r, n) {
  return e.replace(r, n);
}
function gr(e, r) {
  return e.indexOf(r);
}
function Y(e, r) {
  return e.charCodeAt(r) | 0;
}
function Pe(e, r, n) {
  return e.slice(r, n);
}
function X(e) {
  return e.length;
}
function Tr(e) {
  return e.length;
}
function Ge(e, r) {
  return r.push(e), e;
}
function dn(e, r) {
  return e.map(r).join("");
}
var tr = 1, he = 1, ut = 0, G = 0, j = 0, me = "";
function nr(e, r, n, o, i, a, l) {
  return { value: e, root: r, parent: n, type: o, props: i, children: a, line: tr, column: he, length: l, return: "" };
}
function Ce(e, r) {
  return un(nr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function pn() {
  return j;
}
function hn() {
  return j = G > 0 ? Y(me, --G) : 0, he--, j === 10 && (he = 1, tr--), j;
}
function J() {
  return j = G < ut ? Y(me, G++) : 0, he++, j === 10 && (he = 1, tr++), j;
}
function Q() {
  return Y(me, G);
}
function Ke() {
  return G;
}
function ke(e, r) {
  return Pe(me, e, r);
}
function Ae(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ft(e) {
  return tr = he = 1, ut = X(me = e), G = 0, [];
}
function lt(e) {
  return me = "", e;
}
function He(e) {
  return ct(ke(G - 1, Er(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function mn(e) {
  for (; (j = Q()) && j < 33; )
    J();
  return Ae(e) > 2 || Ae(j) > 3 ? "" : " ";
}
function vn(e, r) {
  for (; --r && J() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return ke(e, Ke() + (r < 6 && Q() == 32 && J() == 32));
}
function Er(e) {
  for (; J(); )
    switch (j) {
      case e:
        return G;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Er(j);
        break;
      case 40:
        e === 41 && Er(e);
        break;
      case 92:
        J();
        break;
    }
  return G;
}
function yn(e, r) {
  for (; J() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && Q() === 47)
      break;
  return "/*" + ke(r, G - 1) + "*" + rr(e === 47 ? e : J());
}
function gn(e) {
  for (; !Ae(Q()); )
    J();
  return ke(e, G);
}
function En(e) {
  return lt(Ze("", null, null, null, [""], e = ft(e), 0, [0], e));
}
function Ze(e, r, n, o, i, a, l, f, p) {
  for (var m = 0, d = 0, g = l, E = 0, v = 0, b = 0, x = 1, I = 1, S = 1, _ = 0, $ = "", L = i, c = a, V = o, A = $; I; )
    switch (b = _, _ = J()) {
      case 40:
        if (b != 108 && Y(A, g - 1) == 58) {
          gr(A += N(He(_), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += He(_);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += mn(b);
        break;
      case 92:
        A += vn(Ke() - 1, 7);
        continue;
      case 47:
        switch (Q()) {
          case 42:
          case 47:
            Ge(bn(yn(J(), Ke()), r, n), p);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * x:
        f[m++] = X(A) * S;
      case 125 * x:
      case 59:
      case 0:
        switch (_) {
          case 0:
          case 125:
            I = 0;
          case 59 + d:
            S == -1 && (A = N(A, /\f/g, "")), v > 0 && X(A) - g && Ge(v > 32 ? qr(A + ";", o, n, g - 1) : qr(N(A, " ", "") + ";", o, n, g - 2), p);
            break;
          case 59:
            A += ";";
          default:
            if (Ge(V = Br(A, r, n, m, d, i, f, $, L = [], c = [], g), a), _ === 123)
              if (d === 0)
                Ze(A, r, V, V, L, a, g, f, c);
              else
                switch (E === 99 && Y(A, 3) === 110 ? 100 : E) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ze(e, V, V, o && Ge(Br(e, V, V, 0, 0, i, f, $, i, L = [], g), c), i, c, g, f, o ? L : c);
                    break;
                  default:
                    Ze(A, V, V, V, [""], c, 0, f, c);
                }
        }
        m = d = v = 0, x = S = 1, $ = A = "", g = l;
        break;
      case 58:
        g = 1 + X(A), v = b;
      default:
        if (x < 1) {
          if (_ == 123)
            --x;
          else if (_ == 125 && x++ == 0 && hn() == 125)
            continue;
        }
        switch (A += rr(_), _ * x) {
          case 38:
            S = d > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            f[m++] = (X(A) - 1) * S, S = 1;
            break;
          case 64:
            Q() === 45 && (A += He(J())), E = Q(), d = g = X($ = A += gn(Ke())), _++;
            break;
          case 45:
            b === 45 && X(A) == 2 && (x = 0);
        }
    }
  return a;
}
function Br(e, r, n, o, i, a, l, f, p, m, d) {
  for (var g = i - 1, E = i === 0 ? a : [""], v = Tr(E), b = 0, x = 0, I = 0; b < o; ++b)
    for (var S = 0, _ = Pe(e, g + 1, g = cn(x = l[b])), $ = e; S < v; ++S)
      ($ = ct(x > 0 ? E[S] + " " + _ : N(_, /&\f/g, E[S]))) && (p[I++] = $);
  return nr(e, r, n, i === 0 ? Cr : f, p, m, d);
}
function bn(e, r, n) {
  return nr(e, r, n, Rr, rr(pn()), Pe(e, 2, -2), 0);
}
function qr(e, r, n, o) {
  return nr(e, r, n, wr, Pe(e, 0, o), Pe(e, o + 1, -1), o);
}
function pe(e, r) {
  for (var n = "", o = Tr(e), i = 0; i < o; i++)
    n += r(e[i], i, e, r) || "";
  return n;
}
function xn(e, r, n, o) {
  switch (e.type) {
    case sn:
      if (e.children.length)
        break;
    case an:
    case wr:
      return e.return = e.return || e.value;
    case Rr:
      return "";
    case st:
      return e.return = e.value + "{" + pe(e.children, o) + "}";
    case Cr:
      e.value = e.props.join(",");
  }
  return X(n = pe(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function _n(e) {
  var r = Tr(e);
  return function(n, o, i, a) {
    for (var l = "", f = 0; f < r; f++)
      l += e[f](n, o, i, a) || "";
    return l;
  };
}
function Sn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Rn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var Cn = function(r, n, o) {
  for (var i = 0, a = 0; i = a, a = Q(), i === 38 && a === 12 && (n[o] = 1), !Ae(a); )
    J();
  return ke(r, G);
}, wn = function(r, n) {
  var o = -1, i = 44;
  do
    switch (Ae(i)) {
      case 0:
        i === 38 && Q() === 12 && (n[o] = 1), r[o] += Cn(G - 1, n, o);
        break;
      case 2:
        r[o] += He(i);
        break;
      case 4:
        if (i === 44) {
          r[++o] = Q() === 58 ? "&\f" : "", n[o] = r[o].length;
          break;
        }
      default:
        r[o] += rr(i);
    }
  while (i = J());
  return r;
}, Tn = function(r, n) {
  return lt(wn(ft(r), n));
}, Gr = /* @__PURE__ */ new WeakMap(), Nn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, o = r.parent, i = r.column === o.column && r.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Gr.get(o)) && !i) {
      Gr.set(r, !0);
      for (var a = [], l = Tn(n, a), f = o.props, p = 0, m = 0; p < l.length; p++)
        for (var d = 0; d < f.length; d++, m++)
          r.props[m] = a[p] ? l[p].replace(/&\f/g, f[d]) : f[d] + " " + l[p];
    }
  }
}, On = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Pn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", An = function(r) {
  return r.type === "comm" && r.children.indexOf(Pn) > -1;
}, $n = function(r) {
  return function(n, o, i) {
    if (!(n.type !== "rule" || r.compat)) {
      var a = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (a) {
        for (var l = !!n.parent, f = l ? n.parent.children : (
          // global rule at the root level
          i
        ), p = f.length - 1; p >= 0; p--) {
          var m = f[p];
          if (m.line < n.line)
            break;
          if (m.column < n.column) {
            if (An(m))
              return;
            break;
          }
        }
        a.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, dt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, kn = function(r, n) {
  for (var o = r - 1; o >= 0; o--)
    if (!dt(n[o]))
      return !0;
  return !1;
}, Jr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, In = function(r, n, o) {
  dt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Jr(r)) : kn(n, o) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Jr(r)));
};
function pt(e, r) {
  switch (fn(e, r)) {
    case 5103:
      return T + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return T + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return T + e + Qe + e + W + e + e;
    case 6828:
    case 4268:
      return T + e + W + e + e;
    case 6165:
      return T + e + W + "flex-" + e + e;
    case 5187:
      return T + e + N(e, /(\w+).+(:[^]+)/, T + "box-$1$2" + W + "flex-$1$2") + e;
    case 5443:
      return T + e + W + "flex-item-" + N(e, /flex-|-self/, "") + e;
    case 4675:
      return T + e + W + "flex-line-pack" + N(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return T + e + W + N(e, "shrink", "negative") + e;
    case 5292:
      return T + e + W + N(e, "basis", "preferred-size") + e;
    case 6060:
      return T + "box-" + N(e, "-grow", "") + T + e + W + N(e, "grow", "positive") + e;
    case 4554:
      return T + N(e, /([^-])(transform)/g, "$1" + T + "$2") + e;
    case 6187:
      return N(N(N(e, /(zoom-|grab)/, T + "$1"), /(image-set)/, T + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return N(e, /(image-set\([^]*)/, T + "$1$`$1");
    case 4968:
      return N(N(e, /(.+:)(flex-)?(.*)/, T + "box-pack:$3" + W + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + T + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return N(e, /(.+)-inline(.+)/, T + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (X(e) - 1 - r > 6)
        switch (Y(e, r + 1)) {
          case 109:
            if (Y(e, r + 4) !== 45)
              break;
          case 102:
            return N(e, /(.+:)(.+)-([^]+)/, "$1" + T + "$2-$3$1" + Qe + (Y(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~gr(e, "stretch") ? pt(N(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (Y(e, r + 1) !== 115)
        break;
    case 6444:
      switch (Y(e, X(e) - 3 - (~gr(e, "!important") && 10))) {
        case 107:
          return N(e, ":", ":" + T) + e;
        case 101:
          return N(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + T + (Y(e, 14) === 45 ? "inline-" : "") + "box$3$1" + T + "$2$3$1" + W + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Y(e, r + 11)) {
        case 114:
          return T + e + W + N(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return T + e + W + N(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return T + e + W + N(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return T + e + W + e + e;
  }
  return e;
}
var Ln = function(r, n, o, i) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case wr:
        r.return = pt(r.value, r.length);
        break;
      case st:
        return pe([Ce(r, {
          value: N(r.value, "@", "@" + T)
        })], i);
      case Cr:
        if (r.length)
          return dn(r.props, function(a) {
            switch (ln(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return pe([Ce(r, {
                  props: [N(a, /:(read-\w+)/, ":" + Qe + "$1")]
                })], i);
              case "::placeholder":
                return pe([Ce(r, {
                  props: [N(a, /:(plac\w+)/, ":" + T + "input-$1")]
                }), Ce(r, {
                  props: [N(a, /:(plac\w+)/, ":" + Qe + "$1")]
                }), Ce(r, {
                  props: [N(a, /:(plac\w+)/, W + "input-$1")]
                })], i);
            }
            return "";
          });
    }
}, Dn = [Ln], Mn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(x) {
      var I = x.getAttribute("data-emotion");
      I.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var i = r.stylisPlugins || Dn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var a = {}, l, f = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(x) {
      for (var I = x.getAttribute("data-emotion").split(" "), S = 1; S < I.length; S++)
        a[I[S]] = !0;
      f.push(x);
    }
  );
  var p, m = [Nn, On];
  process.env.NODE_ENV !== "production" && m.push($n({
    get compat() {
      return b.compat;
    }
  }), In);
  {
    var d, g = [xn, process.env.NODE_ENV !== "production" ? function(x) {
      x.root || (x.return ? d.insert(x.return) : x.value && x.type !== Rr && d.insert(x.value + "{}"));
    } : Sn(function(x) {
      d.insert(x);
    })], E = _n(m.concat(i, g)), v = function(I) {
      return pe(En(I), E);
    };
    p = function(I, S, _, $) {
      d = _, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          _.insert(c + S.map);
        }
      }), v(I ? I + "{" + S.styles + "}" : S.styles), $ && (b.inserted[S.name] = !0);
    };
  }
  var b = {
    key: n,
    sheet: new on({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: a,
    registered: {},
    insert: p
  };
  return b.sheet.hydrate(f), b;
}, br = { exports: {} }, O = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kr;
function Fn() {
  if (Kr)
    return O;
  Kr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function $(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case m:
            case o:
            case a:
            case i:
            case g:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case d:
                case b:
                case v:
                case l:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function L(c) {
    return $(c) === m;
  }
  return O.AsyncMode = p, O.ConcurrentMode = m, O.ContextConsumer = f, O.ContextProvider = l, O.Element = r, O.ForwardRef = d, O.Fragment = o, O.Lazy = b, O.Memo = v, O.Portal = n, O.Profiler = a, O.StrictMode = i, O.Suspense = g, O.isAsyncMode = function(c) {
    return L(c) || $(c) === p;
  }, O.isConcurrentMode = L, O.isContextConsumer = function(c) {
    return $(c) === f;
  }, O.isContextProvider = function(c) {
    return $(c) === l;
  }, O.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, O.isForwardRef = function(c) {
    return $(c) === d;
  }, O.isFragment = function(c) {
    return $(c) === o;
  }, O.isLazy = function(c) {
    return $(c) === b;
  }, O.isMemo = function(c) {
    return $(c) === v;
  }, O.isPortal = function(c) {
    return $(c) === n;
  }, O.isProfiler = function(c) {
    return $(c) === a;
  }, O.isStrictMode = function(c) {
    return $(c) === i;
  }, O.isSuspense = function(c) {
    return $(c) === g;
  }, O.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === o || c === m || c === a || c === i || c === g || c === E || typeof c == "object" && c !== null && (c.$$typeof === b || c.$$typeof === v || c.$$typeof === l || c.$$typeof === f || c.$$typeof === d || c.$$typeof === I || c.$$typeof === S || c.$$typeof === _ || c.$$typeof === x);
  }, O.typeOf = $, O;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hr;
function jn() {
  return Hr || (Hr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, I = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function $(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === o || h === m || h === a || h === i || h === g || h === E || typeof h == "object" && h !== null && (h.$$typeof === b || h.$$typeof === v || h.$$typeof === l || h.$$typeof === f || h.$$typeof === d || h.$$typeof === I || h.$$typeof === S || h.$$typeof === _ || h.$$typeof === x);
    }
    function L(h) {
      if (typeof h == "object" && h !== null) {
        var xe = h.$$typeof;
        switch (xe) {
          case r:
            var se = h.type;
            switch (se) {
              case p:
              case m:
              case o:
              case a:
              case i:
              case g:
                return se;
              default:
                var oe = se && se.$$typeof;
                switch (oe) {
                  case f:
                  case d:
                  case b:
                  case v:
                  case l:
                    return oe;
                  default:
                    return xe;
                }
            }
          case n:
            return xe;
        }
      }
    }
    var c = p, V = m, A = f, ir = l, Ie = r, ar = d, sr = o, Le = b, H = v, ee = n, ne = a, De = i, Me = g, ve = !1;
    function Fe(h) {
      return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ye(h) || L(h) === p;
    }
    function ye(h) {
      return L(h) === m;
    }
    function je(h) {
      return L(h) === f;
    }
    function Ve(h) {
      return L(h) === l;
    }
    function Ye(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function cr(h) {
      return L(h) === d;
    }
    function ur(h) {
      return L(h) === o;
    }
    function ge(h) {
      return L(h) === b;
    }
    function Ee(h) {
      return L(h) === v;
    }
    function ie(h) {
      return L(h) === n;
    }
    function be(h) {
      return L(h) === a;
    }
    function ae(h) {
      return L(h) === i;
    }
    function fr(h) {
      return L(h) === g;
    }
    P.AsyncMode = c, P.ConcurrentMode = V, P.ContextConsumer = A, P.ContextProvider = ir, P.Element = Ie, P.ForwardRef = ar, P.Fragment = sr, P.Lazy = Le, P.Memo = H, P.Portal = ee, P.Profiler = ne, P.StrictMode = De, P.Suspense = Me, P.isAsyncMode = Fe, P.isConcurrentMode = ye, P.isContextConsumer = je, P.isContextProvider = Ve, P.isElement = Ye, P.isForwardRef = cr, P.isFragment = ur, P.isLazy = ge, P.isMemo = Ee, P.isPortal = ie, P.isProfiler = be, P.isStrictMode = ae, P.isSuspense = fr, P.isValidElementType = $, P.typeOf = L;
  }()), P;
}
process.env.NODE_ENV === "production" ? br.exports = Fn() : br.exports = jn();
var Vn = br.exports, ht = Vn, Yn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Wn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, mt = {};
mt[ht.ForwardRef] = Yn;
mt[ht.Memo] = Wn;
var zn = !0;
function Un(e, r, n) {
  var o = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? r.push(e[i] + ";") : o += i + " ";
  }), o;
}
var vt = function(r, n, o) {
  var i = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  zn === !1) && r.registered[i] === void 0 && (r.registered[i] = n.styles);
}, Bn = function(r, n, o) {
  vt(r, n, o);
  var i = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var a = n;
    do
      r.insert(n === a ? "." + i : "", a, r.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function qn(e) {
  for (var r = 0, n, o = 0, i = e.length; i >= 4; ++o, i -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      r ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(o) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Gn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Zr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Jn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Kn = /[A-Z]|^ms/g, yt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Nr = function(r) {
  return r.charCodeAt(1) === 45;
}, Xr = function(r) {
  return r != null && typeof r != "boolean";
}, vr = /* @__PURE__ */ Rn(function(e) {
  return Nr(e) ? e : e.replace(Kn, "-$&").toLowerCase();
}), er = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(yt, function(o, i, a) {
          return Z = {
            name: i,
            styles: a,
            next: Z
          }, i;
        });
  }
  return Gn[r] !== 1 && !Nr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Hn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Zn = ["normal", "none", "initial", "inherit", "unset"], Xn = er, Qn = /^-ms-/, eo = /-(.)/g, Qr = {};
  er = function(r, n) {
    if (r === "content" && (typeof n != "string" || Zn.indexOf(n) === -1 && !Hn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var o = Xn(r, n);
    return o !== "" && !Nr(r) && r.indexOf("-") !== -1 && Qr[r] === void 0 && (Qr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Qn, "ms-").replace(eo, function(i, a) {
      return a.toUpperCase();
    }) + "?")), o;
  };
}
var gt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $e(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(gt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Z = {
          name: n.name,
          styles: n.styles,
          next: Z
        }, n.name;
      if (n.styles !== void 0) {
        var o = n.next;
        if (o !== void 0)
          for (; o !== void 0; )
            Z = {
              name: o.name,
              styles: o.styles,
              next: Z
            }, o = o.next;
        var i = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (i += n.map), i;
      }
      return ro(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var a = Z, l = n(e);
        return Z = a, $e(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var f = [], p = n.replace(yt, function(d, g, E) {
          var v = "animation" + f.length;
          return f.push("const " + v + " = keyframes`" + E.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + v + "}";
        });
        f.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(f, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var m = r[n];
  return m !== void 0 ? m : n;
}
function ro(e, r, n) {
  var o = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      o += $e(e, r, n[i]) + ";";
  else
    for (var a in n) {
      var l = n[a];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? o += a + "{" + r[l] + "}" : Xr(l) && (o += vr(a) + ":" + er(a, l) + ";");
      else {
        if (a === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(gt);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var f = 0; f < l.length; f++)
            Xr(l[f]) && (o += vr(a) + ":" + er(a, l[f]) + ";");
        else {
          var p = $e(e, r, l);
          switch (a) {
            case "animation":
            case "animationName": {
              o += vr(a) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && a === "undefined" && console.error(Jn), o += a + "{" + p + "}";
          }
        }
      }
    }
  return o;
}
var et = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Et;
process.env.NODE_ENV !== "production" && (Et = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Z, rt = function(r, n, o) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var i = !0, a = "";
  Z = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (i = !1, a += $e(o, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Zr), a += l[0]);
  for (var f = 1; f < r.length; f++)
    a += $e(o, n, r[f]), i && (process.env.NODE_ENV !== "production" && l[f] === void 0 && console.error(Zr), a += l[f]);
  var p;
  process.env.NODE_ENV !== "production" && (a = a.replace(Et, function(E) {
    return p = E, "";
  })), et.lastIndex = 0;
  for (var m = "", d; (d = et.exec(a)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    d[1];
  var g = qn(a) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: g,
    styles: a,
    map: p,
    next: Z,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: g,
    styles: a,
    next: Z
  };
}, to = function(r) {
  return r();
}, no = te["useInsertionEffect"] ? te["useInsertionEffect"] : !1, oo = no || to, or = {}.hasOwnProperty, Or = /* @__PURE__ */ te.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Mn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Or.displayName = "EmotionCacheContext");
Or.Provider;
var io = function(r) {
  return /* @__PURE__ */ ot(function(n, o) {
    var i = Ut(Or);
    return r(n, i, o);
  });
}, bt = /* @__PURE__ */ te.createContext({});
process.env.NODE_ENV !== "production" && (bt.displayName = "EmotionThemeContext");
var tt = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, ao = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return tt(n[1]);
}, so = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), co = function(r) {
  return r.replace(/\$/g, "-");
}, uo = function(r) {
  if (r)
    for (var n = r.split(`
`), o = 0; o < n.length; o++) {
      var i = ao(n[o]);
      if (i) {
        if (so.has(i))
          break;
        if (/^[A-Z]/.test(i))
          return co(i);
      }
    }
}, xr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", _r = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", xt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var o = {};
  for (var i in n)
    or.call(n, i) && (o[i] = n[i]);
  if (o[xr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var a = uo(new Error().stack);
    a && (o[_r] = a);
  }
  return o;
}, fo = function(r) {
  var n = r.cache, o = r.serialized, i = r.isStringTag;
  return vt(n, o, i), oo(function() {
    return Bn(n, o, i);
  }), null;
}, _t = /* @__PURE__ */ io(function(e, r, n) {
  var o = e.css;
  typeof o == "string" && r.registered[o] !== void 0 && (o = r.registered[o]);
  var i = e[xr], a = [o], l = "";
  typeof e.className == "string" ? l = Un(r.registered, a, e.className) : e.className != null && (l = e.className + " ");
  var f = rt(a, void 0, te.useContext(bt));
  if (process.env.NODE_ENV !== "production" && f.name.indexOf("-") === -1) {
    var p = e[_r];
    p && (f = rt([f, "label:" + p + ";"]));
  }
  l += r.key + "-" + f.name;
  var m = {};
  for (var d in e)
    or.call(e, d) && d !== "css" && d !== xr && (process.env.NODE_ENV === "production" || d !== _r) && (m[d] = e[d]);
  return m.ref = n, m.className = l, /* @__PURE__ */ te.createElement(te.Fragment, null, /* @__PURE__ */ te.createElement(fo, {
    cache: r,
    serialized: f,
    isStringTag: typeof i == "string"
  }), /* @__PURE__ */ te.createElement(i, m));
});
process.env.NODE_ENV !== "production" && (_t.displayName = "EmotionCssPropInternal");
var St = _t, Sr = Oe.Fragment;
function D(e, r, n) {
  return or.call(r, "css") ? Oe.jsx(St, xt(e, r), n) : Oe.jsx(e, r, n);
}
function Xe(e, r, n) {
  return or.call(r, "css") ? Oe.jsxs(St, xt(e, r), n) : Oe.jsxs(e, r, n);
}
const B = {
  maxCount: 5,
  duration: 3e3,
  listener: [],
  NotificationList: []
};
function lo() {
  return {
    getNotification: () => B.NotificationList,
    setNotification: (e) => {
      B.NotificationList = e, B.listener.forEach((r) => {
        r.onStoreChange();
      });
    },
    subscribe: (e) => {
      const r = {
        listenerId: at(),
        onStoreChange: e
      };
      return B.listener.push(r), r.onStoreChange(), r;
    },
    unSubscribe: (e) => {
      B.listener.splice(B.listener.findIndex((r) => r.listenerId === e), 1);
    },
    add: (e) => {
      B.NotificationList.push(e), B.listener.forEach((r) => {
        r.onStoreChange();
      });
    },
    updateConfig: (e) => {
      e.duration != null && (B.duration = e.duration), e.maxCount != null && (B.maxCount = e.maxCount);
    },
    getConfig: () => ({
      maxCount: B.maxCount,
      duration: B.duration
    }),
    remove: (e) => {
      const r = B.NotificationList.findIndex((n) => n.id === e);
      r != -1 && (B.NotificationList.splice(r, 1), B.listener.forEach((n) => {
        n.onStoreChange();
      }));
    }
  };
}
const z = lo();
function po(e) {
  return q`
    position: relative;
    pointer-events: visible;
    padding: 16px ${e ? "40px" : "16px"} 16px 16px;
    margin-bottom: 20px;
    width: 320px;
    display: flex;
    box-sizing: border-box;
    box-shadow: 0 4px 10px 0 ${le(`--${de}-blackAlpha-07`)};
    border-radius: 8px;
    border: 1px solid ${le(`--${de}-grayBlue-08`)};
    background-color: ${le(`--${de}-white-01`)};
    flex-direction: column;
  `;
}
const Po = q`
  flex: 1;
  word-break: break-all;
`, ho = q`
  font-size: 16px;
  font-weight: 500;
  color: ${le(`--${de}-grayBlue-02`)};
  margin-bottom: 4px;
`, mo = q`
  font-size: 14px;
  color: ${le(`--${de}-grayBlue-04`)};
`, vo = q`
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 8px;
  line-height: 0;
  color: ${le(`--${de}-grayBlue-03`)};
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`, yo = q`
  text-align: right;
  margin-top: 16px;
`;
function go(e) {
  return {
    initial: {
      x: `${e === "topLeft" || e === "bottomLeft" ? "-100%" : "100%"}`
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      transition: {
        opacity: { duration: 0.2, ease: "linear" }
      }
    }
  };
}
const Eo = q`
  display: flex;
  flex-direction: row;
`;
function bo(e) {
  return q`
    flex: 1;
    word-break: break-word;
    margin-left: ${e ? "8px" : "0"};
  `;
}
const Ao = q`
  padding-right: 8px;
`;
function Je(e) {
  let r = q``;
  switch (e) {
    case "topLeft":
      r = q`
        top: 20px;
        left: 20px;
        align-items: start;
      `;
      break;
    case "topRight":
      r = q`
        top: 20px;
        right: 20px;
        align-items: end;
      `;
      break;
    case "bottomLeft":
      r = q`
        bottom: 0;
        left: 20px;
        align-items: start;
      `;
      break;
    case "bottomRight":
      r = q`
        bottom: 0;
        right: 20px;
        align-items: end;
      `;
      break;
  }
  return q`
    display: inline-flex;
    pointer-events: none;
    z-index: ${Jt.notification};
    position: fixed;
    flex-direction: column;
    ${r};
  `;
}
const Ne = ot((e, r) => {
  const { type: n, action: o, closable: i, showIcon: a = !0, duration: l, id: f = "", position: p = "topRight", icon: m, content: d, title: g, onClose: E } = e, v = Bt(), b = qt(() => {
    var S;
    let I;
    l ? I = window.setTimeout(() => {
      z.remove(f), E == null || E();
    }, l) : I = window.setTimeout(() => {
      z.remove(f), E == null || E(), v.current = void 0;
    }, ((S = z.getConfig()) == null ? void 0 : S.duration) ?? 3e3), v.current = I;
  }, [l, f, E]);
  it(() => (b(), () => {
    v.current && (clearTimeout(v.current), v.current = void 0);
  }), [b]);
  const x = we(() => {
    if (a) {
      if (m)
        return m;
      switch (n) {
        case "info":
          return D(Xt, { mt: "2px", fs: "16px", c: qe("blue", "03") });
        case "error":
          return D(Zt, { fs: "16px", mt: "2px", c: qe("red", "03") });
        case "success":
          return D(Ht, { fs: "16px", mt: "2px", c: qe("green", "03") });
        case "warning":
          return D(Kt, { fs: "16px", mt: "2px", c: qe("red", "03") });
        case "normal":
        default:
          return D(Sr, {});
      }
    } else
      return D(Sr, {});
  }, [a, m, n]);
  return Xe(Gt.div, { ref: r, css: [po(i), Te(e)], layout: !0, initial: "initial", animate: "animate", exit: "exit", variants: go(p), onMouseEnter: () => {
    v.current && (clearTimeout(v.current), v.current = void 0);
  }, onMouseLeave: () => {
    b();
  }, children: [Xe("div", { css: Eo, children: [x, Xe("div", { css: bo(a), children: [g && D("div", { css: ho, children: g }), d && D("div", { css: mo, children: d })] })] }), o && D("div", { css: yo, children: o }), i && D("div", { css: vo, onClick: () => {
    E == null || E();
  }, children: D(Qt, {}) })] });
});
Ne.displayName = "Notice";
const xo = (e) => {
  const [r, n] = Ue([]), [o, i] = Ue([]), [a, l] = Ue([]), [f, p] = Ue([]);
  it(() => {
    const v = z.subscribe(() => {
      n(z.getNotification().filter((b) => b.position === "topLeft")), i(z.getNotification().filter((b) => b.position === "topRight")), l(z.getNotification().filter((b) => b.position === "bottomLeft")), p(z.getNotification().filter((b) => b.position === "bottomRight"));
    });
    return () => {
      z.unSubscribe(v.listenerId);
    };
  }, []);
  const m = we(() => r.map((v) => D(Ne, { ...v }, v.id)), [r]), d = we(() => o.map((v) => D(Ne, { ...v }, v.id)), [o]), g = we(() => a.map((v) => D(Ne, { ...v }, v.id)), [a]), E = we(() => f.map((v) => D(Ne, { ...v }, v.id)), [f]);
  return Xe(Sr, { children: [D("div", { css: [Je("topLeft"), Te(e)], children: D(Be, { children: m }) }), D("div", { css: [
    Je("topRight"),
    Te(e)
  ], children: D(Be, { children: d }) }), D("div", { css: [
    Je("bottomLeft"),
    Te(e)
  ], children: D(Be, { children: g }) }), D("div", { css: [
    Je("bottomRight"),
    Te(e)
  ], children: D(Be, { children: E }) })] });
};
xo.displayName = "NotificationGroup";
const fe = (e) => (z.getNotification().length > (z.getConfig().maxCount ?? 5) && z.getNotification().shift(), e.id || (e.id = at()), e.position || (e.position = "topRight"), e.type || (e.type = "normal"), z.add(e), e.id), _o = {
  info: (e) => (e.type = "info", fe(e)),
  error: (e) => (e.type = "error", fe(e)),
  success: (e) => (e.type = "success", fe(e)),
  warning: (e) => (e.type = "warning", fe(e)),
  normal: (e) => (e.type = "normal", fe(e)),
  show: fe,
  remove: (e) => {
    z.remove(e);
  },
  clear: () => {
    z.setNotification([]);
  },
  config: (e) => {
    z.updateConfig(e);
  }
};
function So() {
  return _o;
}
const $o = So;
export {
  Ne as Notification,
  xo as NotificationGroup,
  bo as applyContentStyle,
  Eo as applyContentWrapperStyle,
  po as applyNotification,
  yo as applyNotificationAction,
  vo as applyNotificationCloseBtn,
  Je as applyNotificationContainerStyle,
  mo as applyNotificationContentStyle,
  Po as applyNotificationContentWrapper,
  Ao as applyNotificationLeftStyle,
  go as applyNotificationSlide,
  ho as applyNotificationTitle,
  $o as createNotification,
  So as useNotification
};
//# sourceMappingURL=index.js.map
